import { atom } from "jotai";
import { BrandModel } from "../models/BrandModels";

export const selectedBrandAtom = atom<BrandModel | undefined>(undefined);